import { render, staticRenderFns } from "./priceInquiry.vue?vue&type=template&id=1f715335&scoped=true&"
import script from "./priceInquiry.vue?vue&type=script&lang=js&"
export * from "./priceInquiry.vue?vue&type=script&lang=js&"
import style0 from "./priceInquiry.vue?vue&type=style&index=0&id=1f715335&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f715335",
  null
  
)

export default component.exports